<template>
  <section
    class="product-faq-panel"
    :class="`theme-${variant}`"
  >
    <div class="layout">
      <div class="picture">
        <div
          :class="`collections-${$currentCollection.id}-product-faq-silver`"
          class="picture-coin"
        >
          <div
            class="floral-icon"
            :class="floralIcon"
          />
        </div>
      </div>
      <div class="faq-content">
        <h3 v-html="$config.common.faq.title" />
        <FaqList
          class="faq"
        />
      </div>
    </div>
    <PillButton
      v-if="variant === 'history'"
      class="back-btn"
      :label="$config.common.faq.back"
      :to="`/${$currentCollection.id}`"
      :year="$currentCollection.year"
      :inverted="variant === 'history'"
    />
  </section>
</template>
<script>
import FaqList from '@/components/common/faq/FaqList.vue';
import PillButton from '@/components/common/buttons/PillButton.vue';

export default {
  name: 'FaqSection',
  components: {
    FaqList,
    PillButton,
  },

  computed: {
    variant() {
      return this.$route.name === 'product' ? 'product' : 'history';
    },
    floralIcon() {
      switch (this.variant) {
        case 'product':
          return `collections-${this.$currentCollection.id}-common-floral-product`;
        default:
          return 'common-floral-faq';
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.product-faq-panel {
  --bgColor: var(--white-color);
  --textColor: var(--inverted-text-color);
  --accentColor: var(--inverted-text-color);

  &.theme-history {
  --bgColor: var(--main-color);
  --textColor: var(--text-color);
  --accentColor: var(--text-color);
  }


  background: var(--bgColor);
  color: var(--textColor);
  transition: background 200ms ease-in-out, color 200ms ease-in-out;
  padding: 100px 15px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  +mobile() {
    padding: 60px 15px 60px;
  }


  .layout {
    display: grid;
    justify-items: center;
    align-items: center;

    grid-template-rows: auto;
    max-width: 100%;
    gap: 45px;

    +desktop() {
      gap: 0px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      max-width: 1060px;
      justify-items: flex-end;
    }


    .picture {
      margin: 0 auto;

      +desktop() {
        margin-right: 70px;
      }

      .picture-coin {
        position: relative;
        filter: drop-shadow(-25px 10px 25px rgba(0,0,0, 0.3));

        .floral-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

    }

    .faq-content {
      justify-self: flex-start
      h3 {
        display: flex;
        flex-direction: column;
        margin-bottom: 35px;
        font-weight: 300;
        +desktop() {
          text-align: left;
          margin-bottom: 50px;
        }
      }
    }
  }

  .back-btn {
    margin-top: 100px;
  }
}
</style>
